<template>
	<v-flex xs12>
		
		<TextTask v-if="taskType == 6 || taskType == 20" :showButtons="false" validate-method="checkpointsValidator/validateImageTask"></TextTask>
		
		<v-container>
			<Upload
					v-if="taskType == 6 || taskType == 20"
					:max-files="2"
					:instruction-text="`You can upload 2 images (${validExtensions}) by dropping it here`"
					validate-method="checkpointsValidator/validateImageTask">

			</Upload>

			<Upload
					v-if="taskType == 15"
					validate-method="checkpointsValidator/validateCameraTask"
			>

			</Upload>

			<Upload :max-files="1" button-text="Upload file" :instruction-text="`You can upload an image (${validExtensions}) file by dropping it here`" v-if="taskType == 21" validate-method="checkpointsValidator/validateSingleImageTask"></Upload>

		</v-container>
		<v-container>
			<ImageAnswers v-if="taskType == 6 || taskType == 20"   validate-method="checkpointsValidator/validateImageTask"></ImageAnswers>
			<v-container fluid v-if="taskType === 15">

				<ImageAnswers validate-method="checkpointsValidator/validateCameraTask"></ImageAnswers>
				<v-radio-group v-model="mode">
					<v-radio :label="translater.__('Top left corner')" value="3"></v-radio>
					<v-radio :label="translater.__('Top right corner')" value="1"></v-radio>
					<v-radio :label="translater.__('Bottom left corner')" value="4"></v-radio>
					<v-radio :label="translater.__('Bottom right corner')" value="2"></v-radio>
				</v-radio-group>
			</v-container>
			<ImageAnswers v-if="taskType == 21" validate-method="checkpointsValidator/validateSingleImageTask"></ImageAnswers>
			<v-card-actions>
			        	<!--v-btn flat :disabled="!valid" @click="store()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="store"></SuccessButton>
			        	<!--v-btn flat @click="add = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => add = false"></ErrorButton>
			        </v-card-actions>
		</v-container>
	</v-flex>
</template>

<script>
	import Upload from './Upload';
	import ImageAnswers from './ImageAnswers'
	import TextTask from './TextTask'
	import fileTools from '../../../tools/files';
	import SuccessButton from '../../../common/components/SuccessButton'
	import ErrorButton from '../../../common/components/ErrorButton'
	export default {
		name: 'ImageTask',
		components: {
			Upload,
			ImageAnswers,
			TextTask,
			SuccessButton,
			ErrorButton
		},

		data()
		{
			return {
				mMode: "1"
			}
		},

		computed: {

			validExtensions: {
				get()
				{
					const {validExtensions} = fileTools.getValidExtensions(this.taskType,
					this.$store.getters['files/validMimeTypes'])

					return validExtensions.join(', ')
				}
			},

			valid: {
				get()
				{
					return this.$store.getters['checkpointsValidator/isValid'];
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			add: {
				get()
				{
					return this.$store.getters['checkpoints/add']
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setAddCheckpoint', value)
				}

			},

			taskType:{
				get()
				{
					return this.$store.getters['checkpoints/newTask'].type
				}
			},

			mode: {
				get()
				{
					//console.log(this.mMode);
					return this.mMode
				},

				set(value)
				{
					this.mMode = value;
				}
			}

		},

		methods: {
			store()
			{
				if(this.taskType == 6)
				{
					this.$store.dispatch('checkpoints/storeImageTask');
				} else if(this.taskType == 15)
				{
					this.$store.dispatch('checkpoints/storeCameraTask', this.mode);
				} else if(this.taskType == 20)
				{
					this.$store.dispatch('checkpoints/storeImageTaskType20');
				} else if(this.taskType == 21)
				{
					this.$store.dispatch('checkpoints/storeSingleImageTask');
				}
			}
		}

	}
</script>